<template>
  <vac-card :title="$t('Epacks List')" class="constructor2-page">
    <div class="constructor-sort-panel row">
      <div class="flex xs12 md8 constructor-search-wrapper">
        <div class="constructor-search-button" @click="onSearch">
          <va-icon name="entypo entypo-search" />
        </div>
        <va-input
          label=""
          placeholder="Search E-packs"
          :value="searchValue"
          class="input--border"
          removable
          @input="searchValue = $event"
          @keyup.enter="onSearch"
        />
      </div>
      <div class="flex xs12 md2">
        <va-select
          label="Per page"
          :options="perPageList"
          :value="perPage"
          @input="perPage = $event"
          noClear
        />
      </div>
      <div class="flex xs12 md2">
        <va-select
          label="Type"
          :options="AVAILABLE_EPACK_TYPES_LIST"
          key-by="key"
          text-by="name"
          :value="type"
          @input="typeKey = ($event ? $event.key || null : null)"
        />
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 sm8 md10">
        <div class="constructor-action-buttons">
          <va-button
            :style="{
              marginTop: 0,
              marginBottom: 0,
              marginRight: 0,
              marginLeft: 0,
            }"
            @click="$router.push('/panel/builder-pro/untitled')"
          >
            Create New
          </va-button>
        </div>
      </div>
      <div class="flex xs12 sm4 md2">
        <div class="epacks-total" style="text-align: right;">
          Total Epacks: <b>{{totalEpacks}}</b>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12">
        <va-data-table
          :fields="computedFields"
          :data="formattedEpacksList"
          :loading="loading"
          :totalPages="totalPages"
          no-pagination
          @page-selected="loadList"
          api-mode
        >
          <template slot="actions" slot-scope="props">
            <div class="constructor2-page__actions">
              <router-link
                :to="'/panel/builder-pro/' + props.rowData.id"
                class="constructor-icon constructor-icon--view-icon"
                title="Edit Epack"
              >
                <Edit />
              </router-link>
              <a
                class="constructor-icon"
                :href="getPreviewLink({
                  epackId: props.rowData.id,
                  epackType: props.rowData.type,
                  productName: props.rowData.productName,
                  activeLocale: 'ru',
                  activeTemplate: 'master_template'
                })"
                target="_blank"
                title="Preview"
              >
                <Eye/>
              </a>
              <div
                class="constructor-icon constructor2-page__action"
                title="Duplicate Epack"
              >
                <div
                  class="constructor-icon"
                  title="Duplicate Epack"
                  @click="onDuplicateEpack(props.rowData.id)"
                >
                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'">
 <g>
  <path id="svg_1" fill="#8D9CA8" d="m17.7431,2c0.2796,0 0.5465,0.11705 0.7358,0.32276l3.2569,3.53832c0.1699,0.1846 0.2642,0.42634 0.2642,0.67724l0,10.46168c0,0.5523 -0.4477,1 -1,1l-5,0l0,-2l4,0l0,-8l-3,0c-1.1046,0 -2,-0.89543 -2,-2l0,-2l-3,0l0,1l-2,0l0,-2c0,-0.55228 0.4477,-1 1,-1l6.7431,0zm-0.4386,2l-0.3045,0l0,2l2.1454,0l-1.8409,-2z" clip-rule="evenodd" fill-rule="evenodd"/>
  <path id="svg_2" fill="#8D9CA8" d="m10.4789,6.32276c-0.1893,-0.20571 -0.4562,-0.32276 -0.73576,-0.32276l-6.74314,0c-0.55229,0 -1,0.44772 -1,1l0,14c0,0.5523 0.44772,1 1,1l10,0c0.5523,0 1,-0.4477 1,-1l0,-10.4617c0,-0.2509 -0.0943,-0.4926 -0.2642,-0.67722l-3.2569,-3.53832zm-6.4789,13.67724l8,0l0,-8l-3,0c-1.10457,0 -2,-0.8954 -2,-2l0,-2l-3,0l0,12zm5.30447,-12l1.84093,2l-2.1454,0l0,-2l0.30447,0z" clip-rule="evenodd" fill-rule="evenodd"/>
  <g id="svg_12">
   <rect stroke="null" id="svg_8" height="1" width="4" y="12.97561" x="5.93902" fill="#8d9ca8"/>
   <rect stroke="null" id="svg_9" height="1" width="4" y="15.53659" x="5.93902" fill="#8d9ca8"/>
   <rect stroke="null" id="svg_10" height="1" width="4" y="17.97561" x="5.93902" fill="#8d9ca8"/>
   <rect stroke="null" id="svg_11" height="5.60976" width="1" y="12.97561" x="5.93902" fill="#8d9ca8"/>
  </g>
 </g>
</svg>
                </div>
              </div>
              <div
                class="constructor-icon constructor2-page__action constructor2-page__action--change-owner"
                title="Change owner"
              >
                <constructor2-change-owner :epack-id="props.rowData.id" :epack-name="props.rowData.productName">
                  <template #button>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443 393" version="1.1" style="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'">
 <path d="m66.84399009608947,122.40544248155527 c3.361737772357464,3.361737772357464 8.638566324949265,3.8405533259510993 12.479548236250876,0.4788069818866259 l18.24144968855381,-15.840514554977418 l22.560732851028444,16.319672976851464 c3.8405533259510993,2.400763699436188 8.638566324949265,1.9186051801085475 11.521231392502786,-0.9609740729212768 l14.401324947953222,-14.879626199126244 l15.840514554977418,14.879626199126244 c1.4397896265149117,1.4397896265149117 3.8405533259510993,2.400763699436188 6.241231308317184,2.400763699436188 h29.280951147079463 c14.401324947953222,29.760109568953514 44.16143451690674,48.9624476133585 77.76166882646083,48.9624476133585 c48.001559257507324,0 86.88282225608826,-38.880405827879905 86.88282225608826,-86.88282225608826 s-38.880405827879905,-86.88282225608826 -86.88282225608826,-86.88282225608826 c-33.12193305838108,0 -62.88118545663356,18.720608110427857 -77.28251040458679,47.52240083563328 h-121.44394492149354 c-2.400763699436188,0 -4.801527398872376,0.9609740729212768 -6.241231308317184,2.8795792530298234 l-29.760109568953514,29.760109568953514 c-3.361737772357464,3.361737772357464 -3.361737772357464,9.121153429627418 0,12.479548236250876 zm13.440436592102051,-55.67923722660541 h123.36400729179381 c3.8405533259510993,0 6.72004686191082,-2.400763699436188 8.159836488425732,-5.759158506059647 c10.560343036651611,-25.44082640647888 35.522011021256446,-42.24222931730747 63.36377256131172,-42.24222931730747 c37.91951747202873,0 68.64051539683342,30.720997924804692 68.64051539683342,68.64051539683342 c-0.0033489659289121683,37.922946154832836 -30.724426607608795,69.12310250151158 -68.16478565776347,69.12310250151158 c-28.320062791228295,0 -53.281730775833125,-16.802260081529617 -63.84207381248474,-43.19968899035454 c-1.4397896265149117,-3.361737772357464 -4.801527398872376,-5.759158506059647 -8.159836488425732,-5.759158506059647 h-31.68188628065586 l-19.68149646627903,-18.720608110427857 c-3.361737772357464,-3.361737772357464 -9.121153429627418,-3.361737772357464 -12.479548236250876,0.4788069818866259 l-14.879626199126244,15.840514554977418 l-23.03989127290249,-16.32310165965557 c-3.361737772357464,-2.400763699436188 -8.159836488425732,-2.400763699436188 -11.039501458525658,0.4788069818866259 l-16.802260081529617,14.401324947953222 l-14.879626199126244,-15.840514554977418 z" id="svg_26" class="" stroke="none"/><path d="m412.4552167501422,140.64603499940802 c-12.479548236250876,0 -23.521621206879615,7.198862415504456 -27.840904369354245,18.24144968855381 l-20.638956139326094,45.12232287275791 l-29.280951147079463,19.198909361600876 c-0.4788069818866259,-0.4788069818866259 -0.4788069818866259,-0.9609740729212768 -0.9609740729212768,-0.9609740729212768 c-9.121153429627418,-8.638566324949265 -22.082431599855422,-8.638566324949265 -24.47993805062771,-8.159836488425732 h-65.28212059020996 c-15.840514554977418,0 -24.961667984604833,-3.8405533259510993 -35.522011021256446,-8.638566324949265 c-11.521231392502786,-4.801527398872376 -24.47993805062771,-10.560343036651611 -47.52240083563328,-10.560343036651611 c-24.961667984604833,0 -42.72138773918152,12.961278170228004 -56.64012558245659,23.03989127290249 c-11.039501458525658,8.159836488425732 -20.160654888153076,14.879626199126244 -30.24183950293064,14.879626199126244 h-0.4788069818866259 l-14.401324947953222,-14.401324947953222 c-3.361737772357464,-3.361737772357464 -9.121153429627418,-3.361737772357464 -12.961278170228004,0 l-43.68227609503269,43.68227609503269 c-3.361737772357464,3.361737772357464 -3.361737772357464,9.121153429627418 0,12.961278170228004 l115.20374221801758,115.20374221801758 c1.9186051801085475,1.9186051801085475 3.8405533259510993,2.400763699436188 6.241231308317184,2.400763699436188 c2.400763699436188,0 4.801527398872376,-0.9609740729212768 6.241231308317184,-2.400763699436188 l43.68227609503269,-43.68227609503269 c3.361737772357464,-3.361737772357464 3.361737772357464,-9.121153429627418 0,-12.961278170228004 l-85.44277547836305,-84.96018837368489 c9.599454680800438,-3.361737772357464 18.24144968855381,-9.599454680800438 26.401714762330055,-15.840514554977418 c13.440436592102051,-9.599454680800438 26.880016013503077,-19.68149646627903 46.08321122860909,-19.68149646627903 c19.198909361600876,0 29.280951147079463,4.3193688795447365 40.320452605605134,9.121153429627418 c11.521231392502786,4.801527398872376 23.03989127290249,10.082041785478593 42.72138773918152,10.082041785478593 h65.761279012084 c1.9186051801085475,0 8.159836488425732,0.4788069818866259 11.521231392502786,3.361737772357464 c0.9609740729212768,0.9609740729212768 2.400763699436188,2.400763699436188 2.400763699436188,6.72004686191082 c0,16.802260081529617 -6.241231308317184,16.802260081529617 -12.479548236250876,16.802260081529617 l-72.48406882023811,-0.0033481087582111413 c-4.801527398872376,0 -9.121153429627418,3.8405533259510993 -9.121153429627418,9.121153429627418 c0,5.280342952466011 3.8405533259510993,9.121153429627418 9.121153429627418,9.121153429627418 h72.48149730813503 c13.91873784327507,0 30.720997924804692,-6.241231308317184 30.720997924804692,-35.04028108727932 v-1.4397896265149117 l34.56112266540527,-22.560732851028444 c1.4397896265149117,-0.9609740729212768 2.400763699436188,-2.400763699436188 3.361737772357464,-3.8405533259510993 l21.59984449517727,-48.001559257507324 c1.9186051801085475,-4.801527398872376 6.72004686191082,-7.681020934832096 11.521231392502786,-7.681020934832096 c6.72004686191082,0 12.479548236250876,5.759158506059647 12.479548236250876,12.479548236250876 c0,1.9186051801085475 -0.4788069818866259,3.8405533259510993 -1.4397896265149117,5.759158506059647 l-32.16104470252991,72.48149730813503 l-81.60522224986553,62.88461413943767 h-107.04347714424132 c-4.801527398872376,0 -9.121153429627418,3.8405533259510993 -9.121153429627418,9.121153429627418 s3.8405533259510993,9.121153429627418 9.121153429627418,9.121153429627418 h109.92357069969178 c1.9186051801085475,0 3.8405533259510993,-0.4788069818866259 5.280342952466011,-1.9186051801085475 l85.9227910709381,-66.72559605073928 c0.9609740729212768,-0.9609740729212768 1.9186051801085475,-1.9186051801085475 2.8795792530298234,-3.361737772357464 l33.12193305838108,-74.40327401983738 c1.9186051801085475,-4.3193688795447365 2.8795792530298234,-8.638566324949265 2.8795792530298234,-12.961278170228004 c-0.4788069818866259,-16.7954027159214 -13.91873784327507,-30.71756924200058 -30.720997924804692,-30.71756924200058 zm-288.9693867301941,230.88750002861025 l-102.2433212184906,-102.72333681106568 l31.19929917597771,-31.19929917597771 l102.2433212184906,102.72333681106568 z" id="svg_27" class="" stroke="none"/><path d="m274.6907416810962,114.72519300035401 c14.879626199126244,0 26.880016013503077,-12.000389814376831 26.880016013503077,-26.880016013503077 s-12.000389814376831,-26.880016013503077 -26.880016013503077,-26.880016013503077 c-14.879626199126244,0 -26.880016013503077,12.000389814376831 -26.880016013503077,26.880016013503077 c-0.0033489659289121683,14.879626199126244 11.996961131572723,26.880016013503077 26.880016013503077,26.880016013503077 zm0,-36.00116944313049 c4.801527398872376,0 9.121153429627418,3.8405533259510993 9.121153429627418,9.121153429627418 c-0.0033489659289121683,5.276914269661903 -4.32271184527874,8.638566324949265 -9.121153429627418,8.638566324949265 c-4.801527398872376,0 -9.121153429627418,-3.8405533259510993 -9.121153429627418,-9.121153429627418 s3.8405533259510993,-8.638566324949265 9.121153429627418,-8.638566324949265 z"/></svg>
                  </template>
                </constructor2-change-owner>
              </div>
              <div
                title="Download Epack"
                class="constructor-icon"
                @click="onDownloadEpack(props.rowData.id)"
              >
                <Download/>
              </div>
              <div
                class="constructor-icon"
                title="Delete Epack"
                @click="epackForDeleting = props.rowData.id"
              >
                <Trash />
              </div>
            </div>
          </template>
        </va-data-table>
        <div class="va-data-table__pagination">
          <va-pagination
            :value="currentPage"
            @input="currentPage = $event"
            :visible-pages="5"
            :pages="totalPages"
          />
        </div>
      </div>
    </div>
    <va-modal
      :value="epackForDeleting"
      size="medium"
      title="Delete E-package"
      message="Do you really want to delete this E-package?"
      okText="Delete"
      cancelText="Cancel"
      @cancel="epackForDeleting = null"
      @ok="onDeleteEpack"
    />
  </vac-card>
</template>

<script>
import dcopy from "deep-copy";
import { mapActions } from "vuex";
import Edit from "@/components/ui/icons/constructor/Edit.vue";
import Download from "@/components/ui/icons/constructor/Download";
import Trash from "@/components/ui/icons/constructor/Trash.vue";
import Eye from "@/components/ui/icons/Eye.vue";
import { showToastError } from "@/services/Helpers/HelperToast";
import openPreview from "@/mixins/openPreview";
import Constructor2ChangeOwner from "@/components/constructor2/ChangeOwner";
import {AVAILABLE_EPACK_TYPES, AVAILABLE_EPACK_TYPES_LIST} from "@/store/modules/constructor2/consts";

const TABLE_FIELD_MAPPING_ID = {
  name: "mappingId",
  title: "Mapping ID",
  width: "100px",
  callback: (value) => {
    if (!value) return '-'
    return value
  }
}

const TABLE_FIELD_MPN = {
  name: "productMpn",
  title: "MPN",
  width: "80px",
  callback: (value) => {
    if (!value) return '-'
    return value
  }
}

const TABLE_FIELD_EAN = {
  name: "productEan",
  title: "EAN",
  width: "80px",
  callback: (value) => {
    if (!value) return '-'
    return value
  }
}

export default {
  name: "Constructor2Page",

  components: {
    Constructor2ChangeOwner,
    Edit,
    Download,
    Trash,
    Eye,
  },

  mixins: [openPreview],

  data() {
    return {
      loading: false,
      currentPage: 1,
      perPage: '10',
      typeKey: null,
      searchValue: '',
      epacksList: [],
      totalEpacks: 0,
      backendUrl: process.env.VUE_APP_CONSTRUCTOR_2_BASE_URL,

      isUploadEpackPopupShow: false,
      isPublishPopupShow: false,
      epackForDeleting: null,
      epackForCopying: null,
      perPageList: ["10", "25", "50", "100"],
    };
  },

  computed: {
    formattedEpacksList () {
      const outputArr = [];
      this.epacksList.map((dataRow) => {
        const epack = { ...dataRow };
        outputArr.push(epack);
      });
      return outputArr;
    },

    computedFields () {
      return dcopy(this.fields);
    },

    totalPages () {
      return Math.ceil(this.totalEpacks / this.perPage)
    },

    AVAILABLE_EPACK_TYPES_LIST() {
      return AVAILABLE_EPACK_TYPES_LIST;
    },

    type() {
      return AVAILABLE_EPACK_TYPES[this.typeKey] || ''
    },

    fields() {
      const fields = [
        {
          name: "productName",
          title: "Name",
          width: "130px",
        },
        {
          name: "id",
          title: "epack ID",
          width: "270px",
        },
        {
          name: "brandName",
          title: "Brand",
          width: "100px",
        },
        {
          name: "updatedAt",
          title: "Updated",
          width: "150px",
        },
        {
          name: "__slot:actions",
          title: "",
          width: "244px",
        },
      ]

      if (this.typeKey === AVAILABLE_EPACK_TYPES.sis.key) {
        fields.splice(fields.length - 2, 0, TABLE_FIELD_MAPPING_ID)
      } else if (this.typeKey === AVAILABLE_EPACK_TYPES.minisite.key) {
        fields.splice(fields.length - 2, 0, ...[
          TABLE_FIELD_MPN,
          TABLE_FIELD_EAN,
        ])
      } else {
        fields.splice(fields.length - 2, 0, ...[
          TABLE_FIELD_MAPPING_ID,
          TABLE_FIELD_MPN,
          TABLE_FIELD_EAN,
        ])
      }

      return fields
    }
  },

  created() {
    this.loadList();
  },

  watch: {
    perPage () {
      this.onSearch()
    },

    typeKey () {
      this.onSearch()
    },

    currentPage () {
      this.loadList();
    },
  },

  methods: {
    ...mapActions("constructor2", [
      "getEpackages",
      "deleteEpackage",
      "downloadEpackage",
      "copyEpackage",
    ]),

    async loadList () {
      this.loading = true;
      await this.getEpackages({
        page: this.currentPage,
        perPage: this.perPage,
        search: this.searchValue.trim() || undefined,
        type: this.typeKey || undefined
      })
        .then(res => {
          this.epacksList = res.data?.data || []
          this.totalEpacks = res.data?.pagination?.total || 0
        })
        .catch(e => {
          console.error(e)
          showToastError(
            "Something wrong. <br/> Please try later",
            this.$toast
          );
        })
      this.loading = false;
    },

    onSearch () {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.loadList().then()
      }
    },

    async onDeleteEpack () {
      this.loading = true
      await this.deleteEpackage(this.epackForDeleting)
        .then(() => {
          this.epackForDeleting = null
          this.loadList().then()
        })
        .catch((e) => {
          console.error(e)
          showToastError(
            "Something wrong. <br/> Please try later",
            this.$toast
          );
          this.loading = false
        });
    },

    async onDownloadEpack (id) {
      if (!this.loading) {
        this.loading = true
        await this.downloadEpackage(id)
          .catch(e => {
            console.error(e)
            showToastError(
              "Something wrong. <br/> Please try later",
              this.$toast
            );
          })
        this.loading = false
      }
    },

    async onDuplicateEpack (id) {
      if (!this.loading) {
        this.loading = true
        await this.copyEpackage(id)
          .then(() => {
            this.loadList().then()
          })
          .catch(e => {
            console.error(e)
            showToastError(
              "Something wrong. <br/> Please try later",
              this.$toast
            );
            this.loading = false
          })
      }
    }
  },
};
</script>

<style lang="scss">
.constructor2-page {
  .vuetable {
    table-layout: fixed;
  }

  &__actions {
    display: flex;
    align-items: center;

    > * {
      &:not(:last-child) {
        margin-right: 16px;
      }
    }
  }

  &__action {
    min-width: 24px;
    width: 24px;
    height: 24px;

    &--change-owner {
      svg {
        path {
          fill: #8d9ca8 !important;
          stroke: #8d9ca8 !important;
          stroke-width: 10px;
        }
      }
    }
  }
}

body .button--cancel {
  background: #ffffff !important;
  color: #000000 !important;
  border: 1px solid #d6dee2;

  &:hover {
    background: #e3e9ed !important;
    opacity: 1;
    filter: none;
    border: 1px solid #d6dee2;
  }
}

body .input--epack-data {
  border: 1px solid #d6dee2 !important;
}

.dropzone--white {
  padding: 1.5rem 0.5rem 0.5rem;

  .va-file-upload__field__button {
    background: #e3e9ed !important;
    color: #000000 !important;
    border: none;
  }

  .va-file-upload__field {
    padding: 0 0.5rem 1rem;
    text-align: center;
  }

  &.dropzone--vertical {
    .va-file-upload__field__text {
      padding-right: 0;
      padding-bottom: 10px;
    }
  }
}

.constructor-action-buttons {
  display: flex;

  .button--upload {
    background: #ffffff !important;
    color: #000000;
    border: 1px solid #d6dee2;

    &:hover {
      background: #e3e9ed !important;
      opacity: 1;
      filter: none;
      border: 1px solid #d6dee2;
    }
  }
}

.constructor-sort-panel {
  display: flex;
  align-items: center;
}

.constructor-search-wrapper {
  display: flex;
  margin-top: 0.5rem;
}

.constructor-search-button {
  color: #c4d0da;
  background: none;
  border-bottom: 1px solid #d6dee2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  max-width: 40px;
  padding-left: 4px;
  padding-right: 20px;
  margin-bottom: 1rem;
}

.constructor-icon {
  cursor: pointer;
}

.constructor-label {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  margin: 0 auto;

  &-0 {
    background: #c4d0da;
  }

  &-1 {
    background: #f3972b;
  }

  &-2 {
    background: #45db54;
  }
}

.download-epack-button {
  padding: 0;
}

.constructor-icon--view-icon {
  svg {
    &:hover {
      path {
        fill: none;
        stroke: #000000;
      }
    }
  }
}
</style>
